const smoothScrool = () =>
{
	const smoothScrollElems = document.querySelectorAll( 'a[href^="#"]:not(a[href=""])' );

	smoothScrollElems?.forEach( ( link ) =>
	{
		link.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			const id = link?.getAttribute( 'href' ).slice( 1 );

			document.getElementById( id )?.scrollIntoView( {behavior: 'smooth'} );
		} );
	} );

	showMenuAnchored();
};

const showMenuAnchored = () => {
	if ( window.location.hash )
	{
		const body = document.querySelector( 'body' );
		if ( !body.classList.contains( 'scroll-first-screen' ) )
		{
			body.classList.add( 'scroll-first-screen' );
		}
	}
};

export {
	smoothScrool,
};
